import Cookies from 'js-cookie';

const TOKEN_KEY = 'nikao_auth_token';

export const getToken = () => {
  return Cookies.get(TOKEN_KEY) || null;
};

export const setToken = (token) => {
  if (token) {
    Cookies.set(TOKEN_KEY, token, { expires: 1, sameSite: 'strict' }); // 1 day
  }
};

export const removeToken = () => {
  Cookies.remove(TOKEN_KEY);
}; 